import {combineLatest} from 'rxjs';
import {filter, map, startWith, shareReplay} from 'rxjs/operators';
import {wwData$} from '@/streams/worker-data';
import {div, gt, times} from '@/helper/num';
import {currenciesCache$} from './config/currency';
import type {UIndexPrice, PriceEntity} from '@px/ws-data';

export const indexPricesCache$ = wwData$.pipe(
  filter((o) => o.type === 'index-price'),
  map((o: UIndexPrice) => o.data.prices),
  startWith(new Map<string, PriceEntity>()),
  shareReplay(1)
);

/**
 * 计算数字币对应的usd价值
 */
export const calcUsdEvActions$ = combineLatest({
  currencyMaps: currenciesCache$,
  indexPricesCache: indexPricesCache$,
}).pipe(map(calcUsdEvActions), shareReplay(1));

function calcUsdEvActions({currencyMaps, indexPricesCache}) {
  return function calcUsdEv({currencyValues, options}) {
    const currencyKey = (options && options.currencyKey) || 'currency';
    const quantityKey = (options && options.quantityKey) || 'quantity';
    // 使用自定义usd价值
    const usdPriceKey = (options && options.usdPriceKey) || 'usdPrice';
    return currencyValues.map((currencyValueItem) => {
      const currency = currencyValueItem[currencyKey] || '';
      const currencyConfig = currencyMaps.get(currency);

      const quantity = currencyValueItem[quantityKey] || '';
      const currencyIndexPrice = indexPricesCache.get(`.${currency}`);

      let calcPrice = 0;
      let calcValue = '0';

      const customUsdPrice = currencyValueItem[usdPriceKey] || 0;

      if (currency && quantity) {
        if (gt(customUsdPrice, 0)) {
          calcPrice = customUsdPrice;
        }
        if (currencyIndexPrice) {
          calcPrice = div(currencyIndexPrice.priceEp, currencyIndexPrice.priceFactor);
        }
        calcValue = times(quantity, calcPrice);
      }
      return {
        ...currencyValueItem,
        calcPrice: currencyIndexPrice ? currencyIndexPrice.price : calcPrice,
        calcValue,
        _currencyConfig: currencyConfig || {},
      };
    });
  };
}
